<template>
  <div>
    <div class="table-wrapper">
      <PageHeader title="Overview">
        <h4 class="quota-left">Quota(s) Left：{{ quota }}</h4>
      </PageHeader>
      <el-table :data="overviewList" v-loading="overviewListLoading" element-loading-text="Loading..."
        header-row-class-name="table-header" row-class-name="table-row">
        <el-table-column prop="Name" />
        <el-table-column prop="Submitted" label="Submitted" />
        <el-table-column prop="Completed" label="Completed" />
        <el-table-column prop="ToBePushed" label="To Be Pushed" />
      </el-table>
    </div>
    <div class="table-wrapper config">
      <PageHeader title="Parameter Configuration">
        <el-button v-if="admin" type="primary" icon="el-icon-plus" @click="generateVisable = true">
          Newsletter Tools
        </el-button>
        <el-button v-if="admin" type="primary" icon="el-icon-plus" @click="uploadVisible = true">
          Upload Newsletter
        </el-button>
      </PageHeader>
      <el-table :data="configList" v-loading="configListLoading" element-loading-text="Loading..."
        header-row-class-name="table-header">
        <el-table-column prop="ConfigName" label="Setting" min-width="250" />
        <el-table-column prop="ConfigValue" label="Value" min-width="400" :formatter="passwordFormatter" />
        <el-table-column prop="options" label="Operation" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" icon="el-icon-edit" @click="handleEditRow(row)">
              Edit
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- //TA -->
    <div class="table-wrapper config" v-if="admin">
      <PageHeader title="TA Configuration">
      </PageHeader>
      <el-table :data="taList" v-loading="configListLoading" element-loading-text="Loading..."
        header-row-class-name="table-header">
        <el-table-column prop="ConfigName" label="Setting" min-width="250" />
        <el-table-column prop="options" label="Operation" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" icon="el-icon-edit" @click="handleTaRow(row)">
              Edit
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <EditConfigDialog :visible.sync="editConfigDialogVisible" :data.sync="editRow" @success="onSuccess" />
    <TaConfigDialog ref="taConfig" :visible.sync="taConfigDialogVisible" @success="onSuccess" @openInfo="openInfo" />
    <TaInfoDialog :visible.sync="taInfoDialogVisible" :taInfoForm='taInfoForm' :taInfoTitle="taInfoTitle"
      @success="initTaList" />
    <UploadDialog :visible.sync="uploadVisible" :maximumSize="maximumSize" :data.sync="editRow" @success="onSuccess" />
    <GenerateDialog :visible.sync="generateVisable" :maximumSize="maximumSize" :data.sync="editRow"
      @success="onSuccess" />
  </div>
</template>

<script>
import EditConfigDialog from './edit-config-dialog'
import TaConfigDialog from './ta-config-dialog'
import TaInfoDialog from './ta-info-dialog'
import UploadDialog from './upload-dialog'
import GenerateDialog from './generate-dialog'
import { RoleCode } from '@/utils/role-constant'

export default {
  name: 'Overview',
  components: { EditConfigDialog, UploadDialog, GenerateDialog, TaConfigDialog, TaInfoDialog },
  data() {
    return {
      quota: 0,
      maximumSize: 0,
      overviewListLoading: false,
      overviewList: [],
      configListLoading: false,
      configList: [],
      editConfigDialogVisible: false,
      editRow: null,
      uploadVisible: false,
      generateVisable: false,
      taList: [
        { ConfigName: 'TA', }
      ],
      taConfigDialogVisible: false,
      taInfoDialogVisible: false,
      taInfoTitle: '',
      taInfoForm: {}
    }
  },
  computed: {
    admin() {
      return this.$store.state.role === RoleCode.Admin
    },
  },
  created() {
    this.getQuota()
    this.getOverviewList()
    this.getConfigList()
    this.bus.$on('refresh', ({ name }) => {
      if (this.$options.name === name) {
        this.getQuota()
        this.getOverviewList()
        this.getConfigList()
      }
    })
    this.axios.get('/sys/getVideoConfig').then(({ code, data }) => {
      if (200 === code) {
        this.maximumSize = data.maximumSize
      }
    })
  },
  methods: {
    initTaList() {
      this.$refs.taConfig.initList()
    },
    openInfo(title, form) {
      this.taInfoDialogVisible = true
      this.taInfoTitle = title
      this.taInfoForm = form
    },
    passwordFormatter(row, column, cellValue) {
      return row.ConfigName === 'IDoctorAppSignKey' ||
        row.ConfigName === 'OnlineMeetingAppClient'
        ? cellValue.replace(/./g, '*')
        : cellValue
    },
    onSuccess() {
      this.getQuota()
      this.getConfigList()
    },
    getQuota() {
      this.axios.get('/sys/getQuota').then(({ code, data, msg }) => {
        if (code === 200) {
          this.quota = data
        } else {
          this.$message.error(msg)
        }
      })
    },
    getOverviewList() {
      this.overviewListLoading = true
      this.axios('/sys/overviewAdm').then(({ code, data, msg }) => {
        if (200 === code) {
          this.overviewList = data
        } else {
          this.$message.error(msg)
        }
        this.overviewListLoading = false
      })
    },
    getConfigList() {
      this.configListLoading = true
      this.axios.get(`/sys/getConfig`).then(({ code, data, msg }) => {
        if (200 === code) {
          this.configList = data
        } else {
          this.$message.error(msg)
        }
        this.configListLoading = false
      })
    },
    handleEditRow(row) {
      this.editRow = row
      this.editConfigDialogVisible = true
    },
    handleTaRow() {
      this.taConfigDialogVisible = true
    }
  },
}
</script>

<style lang="scss" scoped>
h3 {
  padding: 15px 0 15px;
  color: #000;
  padding-left: 15px;
  font-weight: bold;
}

.el-table {
  ::v-deep .table-header th {
    .cell {
      color: #000;
    }
  }

  ::v-deep .table-row {
    td:first-child .cell {
      font-weight: bold;
      color: #000;
    }
  }
}

.config {
  margin-top: 15px;
}

.quota-left {
  color: $theme-color;
  text-align: right;
  padding-right: 15px;
}
</style>
